import Vue from 'vue'

const state = {
  hasNewInbox: false
}

const actions = {
  LOAD_NOTIFICATIONS: ({ commit }, id) => {
    const url = 'users-activities/' + id + '/unread-notifications'
    Vue.http.get(url)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          if (response.count_new_inboxes > 0 || response.count_notifications > 0) {
            commit('SET_NEW_INBOX', true)
          } else {
            commit('SET_NEW_INBOX', false)
          }
        }
      })
  }
}

const mutations = {
  SET_NEW_INBOX: (state, status) => {
    state.hasNewInbox = status
  }
}

const getters = {
  getNewInbox: state => {
    return state.hasNewInbox
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notification.js